import { render } from "./MyListFolderList.vue?vue&type=template&id=6242ca10&scoped=true&ts=true"
import script from "./MyListFolderList.vue?vue&type=script&lang=ts"
export * from "./MyListFolderList.vue?vue&type=script&lang=ts"

import "./MyListFolderList.vue?vue&type=style&index=0&id=6242ca10&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6242ca10"]])

export default __exports__